import { BrandLanguage } from "entities/brands/languages/type";
import React, { FC } from "react";
import Drawer from "shared/components/Drawer";
import { DrawerHookResult } from "shared/hooks/useDrawerState";
import ActionButtons from "./components/ActionButtons";
import LanguageDetailsContent from "./components/LanguageDetailsContent";
import { LanguageDetailsProvider, useLanguageDetails } from "./context";

const LanguageDetailsContainer: FC<{
  drawerDetails: DrawerHookResult<BrandLanguage>;
  brandId: string;
}> = ({ drawerDetails, brandId }) => (
  <LanguageDetailsProvider drawerDetails={drawerDetails} brandId={brandId}>
    <LanguageDetails />
  </LanguageDetailsProvider>
);

const LanguageDetails: FC = () => {
  const { languageDetailsDrawer, handleCloseDrawer } = useLanguageDetails();

  const title = languageDetailsDrawer.drawerDetails?.id
    ? languageDetailsDrawer.drawerDetails.displayName
    : "Add new language";

  return (
    <Drawer
      title={title}
      isOpen={languageDetailsDrawer.isOpen}
      onCloseDrawer={handleCloseDrawer}
      headingRight={<ActionButtons />}
    >
      <LanguageDetailsContent />
    </Drawer>
  );
};

export default LanguageDetailsContainer;
